import React from "react";
import MobHeader from "components/NewMobHeader";
import { ShimmerLayout, ShimmerRow, PollingLoaderLayout } from "components/ShimmerRow/shimmer";
import { CircularLoader } from "@nykaa/payment-ui/src/CircularLoader";


export const SavedPaymentShimmer = () => (
  <div className="prl15">
    <ShimmerLayout className="layout horizontal justified center wrap p10 ">
      <ShimmerRow margin="15px 10px 10px 10px" width="60%" height="34px" />
      <ShimmerRow width="100%" height="79px" className="mrl10 mb10" />
      <ShimmerRow width="100%" height="250px" className="mrl10 mtb10" />
    </ShimmerLayout>
  </div>
  );

export const PollingLoader = () => (
  <PollingLoaderLayout>
    <div className="pollingLoader">
      <span></span>
    </div>
  </PollingLoaderLayout>
  );

export const CheckoutSinglePageShimmer = ({ headerTitle }: { headerTitle: string }) => (
  <>
    <MobHeader title={headerTitle} fixAtTop />
    <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
      <CircularLoader />
    </div>
  </>
  );
